// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16FVQ","name":"Header_name__2NaWy","birthday":"Header_birthday__2HihI","skeleton":"Header_skeleton__3HGmF"};